export default __webpack_public_path__ + "static/media/DocumentChart.d1ed115a.svg";